"use client";

import { addNextjsError } from "@datadog/browser-rum-nextjs";
import { useEffect } from "react";

/**
 * payments 세그먼트 에러 바운더리 (SD-7923).
 *
 * payments 라우트(로그인/이용현황/이용권) 렌더 중 미처리 예외를 잡아 폴백 UI 를 보여주고
 * Datadog RUM 으로 리포트한다. 루트 레이아웃 하위라 globals.css/Tailwind 가 정상 동작한다.
 * (이벤트 핸들러 내부 오류는 바운더리가 못 잡으므로 그쪽은 rum-events 로 별도 계측한다.)
 */
export default function PaymentsError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    addNextjsError(error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <h2 className="text-xl font-bold text-gray-900">문제가 발생했습니다</h2>
      <p className="text-sm text-gray-500">
        잠시 후 다시 시도해 주세요. 문제가 계속되면 고객센터로 문의해 주세요.
      </p>
      <button
        type="button"
        onClick={() => unstable_retry()}
        className="mt-2 rounded-lg bg-primary px-5 py-2.5 font-semibold text-primary-foreground transition hover:bg-primary/80"
      >
        다시 시도
      </button>
    </div>
  );
}
